import { IlluProdukte } from './IlluProdukte';
import { IlluItSystembetreuung } from './IlluItSystembetreuung';
import { IlluKomplettLoesung } from './IlluKomplettLoesung';
import { IlluDigitaleVerwaltungssysteme } from './IlluDigitaleVerwaltungssysteme';
import { IlluHardwareIndividualentwicklung } from './IlluHardwareIndividualentwicklung';

export const LoesungenUndProdukteController = ({ hoveredItem }) => {
  const getIllustration = () => {
    if (hoveredItem === null) {
      return <IlluItSystembetreuung />;
    } else {
      switch (hoveredItem.title) {
        case 'IT-Systembetreuung':
          return <IlluItSystembetreuung />;
        case 'IT System Support':
          return <IlluItSystembetreuung />;
        case 'Produkte':
          return <IlluProdukte />;
        case 'Products':
          return <IlluProdukte />;
        case 'Komplettlösungen aus Soft- & Hardware':
          return <IlluKomplettLoesung />;
        case 'Complete Software and Hardware Solutions':
          return <IlluKomplettLoesung />;
        case 'Digitale Systeme zur Verwaltung':
          return <IlluDigitaleVerwaltungssysteme />;
        case 'Digital Management Systems':
          return <IlluDigitaleVerwaltungssysteme />;
        case 'Individuelle Hardware':
          return <IlluHardwareIndividualentwicklung />;
        case 'Customised Hardware':
          return <IlluHardwareIndividualentwicklung />;

        default:
          return <IlluItSystembetreuung />;
      }
    }
  };

  return <>{getIllustration()}</>;
};
